module.exports = __webpack_public_path__ + "static/media/tree.d06a0300.svg";